import { memo, useMemo } from "react"
import type { FC, ReactNode } from "react"
import { Grid, useTheme } from "@mui/material"

import { devicesStatusPlotDef } from "helpers/config/dashboards/global/pies"
import { formatDevicesWithStatus, getDevicesByStatus } from "helpers/utils/devices"
import useOrgDeviceStatuses from "helpers/hooks/devices/useOrgDeviceStatuses"
import type { IDevsWRelsByIdWStates } from "types/device.types"
import PieChartSkeleton from "widgets/skeletons/PieChartSkeleton"

import OrgPieChart from "./OrgPieChart"

const OrgPieChartMemo = memo(OrgPieChart)

interface Props {
  devsWRelsByIdWStates: IDevsWRelsByIdWStates
  subtitle?: ReactNode
}

const OrgDevicesByStatusPieChart: FC<Props> = ({ devsWRelsByIdWStates, subtitle }) => {
  const theme = useTheme()
  const { statusesById, isLoading, isError } = useOrgDeviceStatuses()

  const devicesByStatus = useMemo(() => {
    const devicesWithStatusById = formatDevicesWithStatus(
      devsWRelsByIdWStates,
      statusesById,
    )
    return getDevicesByStatus(devicesWithStatusById)
  }, [statusesById, devsWRelsByIdWStates])

  return (
    <>
      <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
        {isLoading ? (
          <PieChartSkeleton />
        ) : (
          <OrgPieChartMemo
            def={devicesStatusPlotDef(theme)}
            data={devicesByStatus}
            isError={isError}
            subtitle={subtitle}
          />
        )}
      </Grid>
    </>
  )
}

export default OrgDevicesByStatusPieChart
